export default "__VITE_ASSET__hGJiJJz2__"